import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styles/styled-components';
import translations from 'translations';
import { Category } from 'types/schema';
import media from 'utils/mediaStyle';
import messages from '../messages';
import { SearchType } from '../types';

const Container = styled.div`
  margin-top: 12px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${media.md`
    margin-top: 20px;
    gap: 20px;
`}
`;

const CustomInput = styled(Input)`
  padding: 12px;
  border-radius: 6px;
  font-size: 16px;
  line-height: 24px;
  height: 48px;
  width: 100%;
  ${media.md`
        width: 542px;
    `}
`;

const Categories = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${media.md`
    flex-wrap: wrap;
    gap: 12px;
`}
`;

const CategoryItem = styled.div`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #f1f1f1;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
  color: #343538;
  cursor: pointer;
  background-color: #ffffff;
  ${(props) => props.selected && 'border-color: #43a047; color: #43a047; '}
  &:hover {
    border-color: #43a047;
  }
`;

interface IProps {
  onSearch: (data: any) => void;
  categories: Category[];
  search: SearchType;
  locale: string;
}

const SearchSection = ({ onSearch, categories, search, locale }: IProps) => {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue(search?.name || '');
  }, [search?.name]);

  return (
    <Container>
      <CustomInput
        value={searchValue}
        placeholder={translations(messages.placeholderSearch)}
        onPressEnter={() => {
          onSearch({
            ...search,
            name: searchValue !== '' ? searchValue : undefined,
          });
        }}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        suffix={
          <SearchOutlined
            onClick={() => {
              onSearch({
                ...search,
                name: searchValue !== '' ? searchValue : undefined,
              });
            }}
            style={{ fontSize: '21px', color: '#000000', cursor: 'pointer' }}
          />
        }
      />
      <Categories>
        <CategoryItem
          key={'-1'}
          selected={!search?.categoryId}
          onClick={() => {
            onSearch({
              ...search,
              name: search.name !== '' ? searchValue : undefined,
              categoryId: undefined,
            });
          }}
        >
          {locale === 'vi' ? 'Tất cả' : 'All'}
        </CategoryItem>
        {categories?.map((category) => (
          <CategoryItem
            key={category.name}
            selected={Number(search?.categoryId) === Number(category.id)}
            onClick={() => {
              if (Number(search?.categoryId) === Number(category.id)) {
                onSearch({
                  ...search,
                  name: search.name !== '' ? searchValue : undefined,
                  categoryId: undefined,
                });
              } else {
                onSearch({
                  ...search,
                  name: search.name !== '' ? searchValue : undefined,
                  categoryId: category.id,
                });
              }
            }}
          >
            {category.nameLocal}
          </CategoryItem>
        ))}
      </Categories>
    </Container>
  );
};

export default SearchSection;
